import {
  Breadcrumbs,
  Container,
  Grid,
  Paper
} from "@mui/material";
import Typography from "@mui/material/Typography";
import { makeStyles } from '@mui/styles';
import {Link} from 'react-router-dom';
import {Box, IconButton, Stack} from '@mui/material';
import repuestoCritico from '../img/repuesto-critico.svg';
import {FindInPageOutlined, PlaylistAddCheckOutlined} from '@mui/icons-material';
import Share from '../components/common/Share';

const useStyles = makeStyles((theme) => ({
  main: {
    height: 'calc(100vh - 96px)',
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    height: '100%',
    display: 'flex !important',
    flexFlow: 'column nowrap',
  },
  buttonIcon: {
    borderRadius: '50%',
    backgroundColor: '#ff3036 !important',
    width: '86px',
    height: '86px',
    padding: 0,
    color: 'white !important',
    marginBottom: '14px !important',
    '& img': {
      height: '50px'
    }
  },
  disabled: {
    '& a': {
      backgroundColor: '#FFB9B6 !important',
      pointerEvents: 'none',
    },
    '& span': {
      color: 'gray'
    }
  }
}));

const Warehouse = () => {
  const classes = useStyles();
  return <div style={{marginTop: '-24px'}} className={classes.main}>
    <Breadcrumbs aria-label="breadcrumb" className='breadcrumb-custom'>
      <Typography>LATINOAMERICA </Typography>
      <Link to="/assets">Assets</Link>
      <Typography>warehouse</Typography>
    </Breadcrumbs>
    <Container fixed className={classes.container}>
      <Grid container spacing={2} sx={{marginBottom: 'auto'}}>
        <Grid item xs={12} md={12}>
          <Paper style={{padding: '40px 40px 26px', margin: '20px auto 30px'}}>
            <Typography>Esta sección es para mapear repuestos críticos, conocer catálogos y otros.</Typography>
            <br/>
            <Typography>Condiciones ALAXS:</Typography>
            <ul>
              <li>Informacion técnica y de catalogación que nosotros compilamos de fuentes oficiales.</li>
              <li>Repuestos que nuestros clientes puedan tener y puedan ayudar en efectividad y oportunidad.</li>
              <li>Artículos que probablemente sean de 2do uso o almacenados desde hace un tiempo.</li>
              <li>La comisión de ALAXS va desde $9 hasta un maximo del 1% de la operación.</li>
            </ul>
          </Paper>
        </Grid>
        <Grid item xs={12} me={12}>
          <Box sx={{display: 'flex', justifyContent: 'center', textAlign: 'center'}}>
            <Stack direction="row" spacing={8}>
              <Box className={classes.disabled}>
                <IconButton gutterBottom className={classes.buttonIcon} color="primary" component={Link} to="/assets/warehouse/repuesto-critico">
                  <img src={repuestoCritico} alt='icon'/>
                </IconButton>
                <Typography align='center' variant="button" display="block">Repuesto <br/>critico</Typography>
              </Box>
              <Box>
                <IconButton gutterBottom className={classes.buttonIcon} color="primary" component={Link} to="/assets/warehouse/catalog">
                  <FindInPageOutlined sx={{fontSize: '56px'}}/>
                </IconButton>
                <Typography align='center' variant="button" display="block">Catálogos <br/>ALAXS</Typography>
              </Box>
              <Box className={classes.disabled}>
                <IconButton gutterBottom className={classes.buttonIcon} color="primary" component={Link} to="/assets/warehouse/planning">
                  <PlaylistAddCheckOutlined sx={{fontSize: '56px'}}/>
                </IconButton>
                <Typography align='center' variant="button" display="block">Planning</Typography>
              </Box>
            </Stack>
          </Box>
        </Grid>
      </Grid>
      <Share variant="fixed"/>
    </Container>
  </div>
}

export default Warehouse;
